
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/press-inquiries",
      function () {
        return require("private-next-pages/contact-us/press-inquiries.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-us/press-inquiries"])
      });
    }
  